import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { updateContentRequest, updateContentRequestError, updateContentRequestSuccess } from "../../slices/Content/UpdateContentSlice";

export const UpdateContentAPI =
    (data) => async (dispatch) => {
        try {
            dispatch(updateContentRequest());
            // Returning the promise so we can await it in handleSubmit
            const response = await axiosInstance({
                method: "POST",
                url: endpoints.updateContent,
                data: data,
                headers: { "Content-Type": "application/json" },
            })
            return dispatch(updateContentRequestSuccess(response.data));
        } catch (error) {
            const _error = {
                data: error?.response?.data?.message || error?.message,
                status: error?.response?.status || error?.status,
            };
            return dispatch(updateContentRequestError(_error));
        }
    };
